import { Component, DestroyRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { select, Store } from '@ngrx/store';
import { selectBidActivity } from 'app/manage-auctions/features/auction.selectors';
import * as AuctionActions from '../../features/auction.actions'
import _ from 'lodash'
import { CommonModule, DatePipe } from '@angular/common';
import * as moment from 'moment';
import { debounceTime, Subject } from 'rxjs';
import { LoadingService } from 'app/core/services/loading.service';
import { ModalAuctionDetailService } from 'app/manage-auctions/services/modal-auction-detail/modal-auction-detail.service';

@Component({
  selector: 'app-auction-bid-activity',
  standalone: true,
  imports: [CommonModule],
  providers:[DatePipe],
  templateUrl: './auction-bid-activity.component.html',
  styleUrl: './auction-bid-activity.component.scss'
})
export class AuctionBidActivityComponent implements OnInit,OnDestroy {
  destroyRef = inject(DestroyRef)

  @Input() auction;

  constructor(
    private store: Store,
    private loadingService: LoadingService,
    private modalAuctionDetailService: ModalAuctionDetailService
  ){ }

  public moment = moment;
  bidActivitySelector$ = this.store.pipe(
    takeUntilDestroyed(this.destroyRef),
    select(selectBidActivity)
  );

  bidsList: any[] = [];
  attempNumber = 1;
  highlightActivities: any[];
  timestamp: number;
  isFirstCall = true;
  updateRecentActivitesSubject$ = new Subject();

  ngOnInit(): void {
    this.store.dispatch(
      AuctionActions.loadBidActivy({
        campaignId: this.auction.id,
        since: 0
      })
    )

    this.bidActivitySelector$.subscribe(list => {
      this.loadingService.enabled = true;
      if(!list){
        return;
      }

      if(list.length === 0){
        this.updateRecentActivitesSubject$.next(this.attempNumber++);
        return;
      }

      this.updateRecentActivities(list)
    })

    this.updateRecentActivitesSubject$.pipe(
      debounceTime(5000),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(_ => {
      this.loadingService.enabled = false;
      this.store.dispatch(
        AuctionActions.loadBidActivy({
          campaignId: this.auction.id,
          since: this.timestamp,
        })
      )
    });
  }

  getImageUrl(bid) {
    const imageUrl = _.get(bid.optionInfo, 'imageUrl', '');
    return _.isEmpty(imageUrl) ? '/images/org_logo_default_v2.svg' : imageUrl;
  }

  isHighLight(id) {
    return this.highlightActivities.find(activity => {
      return activity.id === id;
    });
  }

  updateRecentActivities(recentActivities): void {
    this.highlightActivities = !this.isFirstCall ? recentActivities : [];
    this.timestamp = Math.round(Date.now() / 1000);
    this.bidsList = [].concat(recentActivities, this.bidsList);
    this.bidsList = _.uniqBy(this.bidsList, 'id').slice(0, 10);
    this.isFirstCall = false;
    this.updateRecentActivitesSubject$.next(this.attempNumber++);
  }

  openAuctionDetailModal(userId) {
    const data = {
      userId,
      placeOfCall: 'bidderDetails'
    }

    this.modalAuctionDetailService.open(data);
  }
  
  ngOnDestroy(): void {
    this.loadingService.enabled = true;
    this.updateRecentActivitesSubject$.next(null);
    this.updateRecentActivitesSubject$.complete();
  }
}